import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-i18next';
import Button from '@material-ui/core/Button';
import styles from './styles';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import DialogPopup from '@Components/DialogPopup';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class WhitelistButton extends Component {
  constructor(props) {
    super();

    this.actionClicked = this.actionClicked.bind(this);
  }

  state = {
    open: false,
    optionValue: '',
    // date: new Date(),
  };

  actionClicked(){
    this.props.onActionClicked(this.props.cardData.type, this.props.actionType, this.state.optionValue);
    this.setState({ open: false });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  onChangeDate = (date) => {
    this.setState({date})
  } 

  handleOptionChange = event => {
    this.setState({ optionValue: event.target.value });
  };


  handleClose = () => {
    this.setState({ open: false });
  };


  render() {
    const { classes, t } = this.props;
    // const {date} = this.state

    return (
      <div className={classes.root}>
        <Button variant="contained"  color="default" className={classes.button} onClick={this.handleClickOpen}>
          {t("_whitelist_domain")}
        </Button>

        <DialogPopup open={this.state.open} onClose={this.handleClose} >
          <DialogTitle>
            {t("_reason_for_whitelisting_this_domain")}
          </DialogTitle>
          <DialogContent>
            <FormControl component="fieldset" className={classes.optionFormControl}>
              <RadioGroup
                aria-label="removedomain"
                name="whitelistRadio"
                className={classes.group}
                value={this.state.optionValue}
                onChange={this.handleOptionChange}
              >
                <FormControlLabel
                  value="customer"
                  control={<Radio color="secondary" />}
                  label={t("_customer_or_partner_domain")}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="tolerated"
                  control={<Radio color="secondary" />}
                  label={t("_tolerated_usage")}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="junk"
                  control={<Radio color="secondary" />}
                  label={t("_junk_domain")}
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl> 
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
            { t("_cancel")}
            </Button>
            <Button onClick={this.actionClicked} color="primary" disabled={!this.state.optionValue}>
              {t("_yes")}
            </Button>
          </DialogActions>
        </DialogPopup>

      </div>
    );
  }
}

WhitelistButton.propTypes = { 
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(translate("translations")(WhitelistButton));